import React from "react";
import { DownloadOutlined, RightOutlined } from "@ant-design/icons";
import { FranjaFija } from "./franjaFija";

// Color de los costados (sacado de los bordes de la imagen de fondo) cuando la pantalla supera los 1280 px
const BORDE_IZQ = "linear-gradient(180deg, #0B0C09 0%, #0A0C05 20%, #0C0D05 40%, #0E0F0C 60%, #111106 80%, #111107 100%)";
const BORDE_DER = "linear-gradient(180deg, #161610 0%, #11120E 20%, #0D0F04 40%, #180906 60%, #141406 80%, #121205 100%)";

// La página arma estos textos cuando una asociación no cargó el archivo ("Sin reglamento general", etc.)
const esArchivoValido = (archivo) => Boolean(archivo) && !/^sin (reglamento|anexo)/i.test(archivo);

// Sección de reglamentos del campeonato seleccionado: items = [{ id, nombre, fecha, archivo }]
export const ReglamentosAsociacion = ({ items = [], campeonato, idAsociacion }) => (
  <FranjaFija izq={BORDE_IZQ} der={BORDE_DER}>
  <section
    className="reglamentos-asoc"
    id="reglamentos"
    // la ruta de la imagen se pasa como variable CSS: las rutas de public/ no se pueden poner directo en App.css
    style={{ "--reglamentos-fondo": "url('/img/asocreg-fondo.png')" }}
  >
    <div className="reglamentos-asoc-cabecera">
      <span className="reglamentos-asoc-barra" />
      <h2 className="reglamentos-asoc-titulo">Reglamentos</h2>
      <p className="reglamentos-asoc-subtitulo">
        Documentación oficial {campeonato && <>- <span>{campeonato}</span></>}
      </p>
    </div>

    <div className="reglamentos-asoc-panel">
      {items.length === 0 ? (
        <p className="reglamentos-asoc-vacio">No hay reglamentos disponibles.</p>
      ) : (
        items.map((item) => (
          <div className="reglamento-asoc-item" key={item.id}>
            <img src="/img/asocreg-pdf.png" alt="" aria-hidden="true" />
            <div className="reglamento-asoc-datos">
              <span>{item.nombre}</span>
              <span>Año {item.fecha}</span>
            </div>
            {esArchivoValido(item.archivo) ? (
              <a
                className="reglamento-asoc-descargar"
                href={`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${idAsociacion}/PDFS/${item.archivo}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <DownloadOutlined />
                <span>Descargar</span>
                <RightOutlined />
              </a>
            ) : (
              <span className="reglamento-asoc-descargar reglamento-asoc-descargar--sin-archivo">Sin archivo</span>
            )}
          </div>
        ))
      )}
    </div>
  </section>
  </FranjaFija>
);
